import { render, staticRenderFns } from "./autocomplete-user.vue?vue&type=template&id=55d0a835&"
import script from "./autocomplete-user.vue?vue&type=script&lang=js&"
export * from "./autocomplete-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports